import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

const Notes = () => {
  return (
    <Box minWidth='320px' maxWidth="1024px" m="0 auto" paddingTop={2}>
      <Paper>
        <Box m={2}>
          <Typography variant="h3">Translation Notes</Typography>
          <Stack>
            <Typography variant="body1">
              At some point, we intend to add common translation notes and extra
              details about Japanes media and culture under this page.
              Currently, this is page is under construction and will be updated
              sometime likely after our first couple releases.
            </Typography>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default Notes;
